/**
 * Reuseable API endpoints
 */

export const API_ENDPOINTS = {
  AUTH: {
    REFRESH_TOKENS: "/auth/refresh-tokens",
    SIGN_OUT: "/auth/signout",
  },
};
